import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © 
        </p>
      </div>
    </div>
  );
};

export default Footer;
